export const aboutStats = [
  { value: "12,000+", label: "Artists Supported" },
  { value: "45,000+", label: "Releases Distributed" },
  { value: "150+", label: "Countries Reached" },
  { value: "2.4M", label: "Monthly Listeners" }
];

export const aboutPillars = [
  { title: "Discover", desc: "A home for music fans to find new sounds before they break big." },
  { title: "Promote", desc: "Professional-grade promotion and distribution tools, built for African artists." },
  { title: "Create", desc: "AI-powered tools like the EPK generator that make professional presentation accessible to everyone." },
  { title: "Connect", desc: "A community spanning music, fashion, and culture — not just a platform." }
];
